const GRADES = [0, 1, 2, 3, 4, 5];


export {
    GRADES,
};
